<template >
   <el-dialog :before-close="handleClose" width="90%" :title="'Nr. comanda: #' + this.NrComanda" :visible.sync="showPopup">
      <template>
         <el-table :data="this.selectedObject" :width="'100'" >
            
            <el-table-column label="Nume">
               <template #default="scope">
                  <el-tooltip style="white-space: pre"
                     v-if="scope.row.Diferente && scope.row.Diferente.Nume && scope.row.Diferente.Nume.NumeBD"
                     class="item"
                     effect="dark"
                     :content="'Numele nu corespunde: In Service: ' + scope.row.Diferente.Nume.NumeBD + '; In Evio: ' + scope.row.Diferente.Nume.NumeAPI"
                     placement="top"
                  >
                     <span style="color: red;">{{ scope.row.Output.NumeClient || '-' }}</span>
                  </el-tooltip>
                  <span v-else>{{ scope.row.Output.NumeClient || '-' }}</span>
               </template>
            </el-table-column>
            
            <el-table-column label="Telefon">
               <template #default="scope">
                  <el-tooltip style="white-space: pre"
                     v-if="scope.row.Diferente && scope.row.Diferente.Telefon && scope.row.Diferente.Telefon.TelefonBD"
                     class="item"
                     effect="dark"
                     :content="'Telefonul nu corespunde: In Service: ' + scope.row.Diferente.Telefon.TelefonBD + '; In Evio: ' + scope.row.Diferente.Telefon.TelefonAPI"
                     placement="top"
                  >
                     <span style="color: red;">{{ scope.row.Output.Telefon || '-' }}</span>
                  </el-tooltip>
                  <span v-else>{{ scope.row.Output.Telefon || '-' }}</span>
               </template>
            </el-table-column>

            <el-table-column label="Email">
               <template #default="scope">
                  <el-tooltip style="white-space: pre"
                     v-if="scope.row.Diferente && scope.row.Diferente.Email && scope.row.Diferente.Email.EmailBD"
                     class="item"
                     effect="dark"
                     :content="'Email nu corespunde: In Service: ' + scope.row.Diferente.Email.EmailBD + '; In Evio: ' + scope.row.Diferente.Email.EmailAPI"
                     placement="top"
                  >
                     <span style="color: red;">{{ scope.row.Output.Email || '-' }}</span>
                  </el-tooltip>
                  <span v-else>{{ scope.row.Output.Email || '-' }}</span>
               </template>
            </el-table-column>

            <el-table-column label="Data verificare">
               <template slot-scope="scope">
               {{scope.row.Data | DataOraFaraSec}}
               </template>
            </el-table-column>

            <el-table-column prop="Status" label="Status"/>

            <el-table-column min-width="380px" label="Produse">
               <template #default="scope">
                  <el-table :data="scope.row.Output.Produse" border style="width: 100%;" size="small">
                     <el-table-column
                     prop="Denumire"
                     label="Denumire"
                     >
                     <template #default="props">
                        <el-tooltip
                           class="item"
                           effect="dark"
                           :content="props.row.Denumire"
                           placement="top"
                        >
                           <span>{{ props.row.Denumire.length > 70 ? props.row.Denumire.substring(0, 70) + '...' : props.row.Denumire }}</span>
                        </el-tooltip>
                     </template>
                     </el-table-column>

                     <el-table-column
                     prop="StatusSosire"
                     label="Status Sosire"
                     width="120"
                     />
                  </el-table>
               </template>
            </el-table-column>
         </el-table>
      </template>

   </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import moment from 'moment';
export default {
   name: 'Preview_history',
   extends: BasePage,
   data() {
      return {
         NrComanda: '',
         showPopup: false,
         selectedObject: {
         }
      }
   },
   methods: {
      handleClose() {
         console.log( document.documentElement.style.getPropertyValue(PointerEvent))
         document.querySelector('body').style.setProperty("pointer-events", "unset");
         this.showPopup = false;
      },
      format(data) {
         return moment(data).format('DD.MM.YYYY HH:mm')
      },
      async get_info() {
         let args = { NrComanda: this.NrComanda };
         let res = await this.post('admin/rapoarte/get_history', args);
         if (res.Success) {
            this.selectedObject = res.Data;
         }
      },
      show_me(NrComanda) {
         this.NrComanda = NrComanda;
         this.get_info();
         this.showPopup = true;
      }
   }
}
</script>


<style lang="less">
.content {
   // width: 700px;
   width: 100%;
   img {
       width: 100%;
   }

}
</style>